export default __webpack_public_path__ + "static/media/dashboard-active.286c64d6.svg";